<template>
  <DatatableReportV3
    title="Purchase Orders"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useStore } from "vuex";
import { customerClassificationColumns } from "@/lib/customerTypes";

import { Filter } from "@/components/DatatableV3.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import PurchaseOrderModalLink from "@/Reports/PurchaseOrderModalLink.vue";

withDefaults(
  defineProps<{
    source?: string;
    filters?: Filter[];
  }>(),
  {
    source: "",
    filters: () => []
  }
);

const config = {
  responsive: true,
  order: [[0, "desc"]],
  columns: [
    {
      data: "po_date",
      filterName: "po_date",
      title: "Created Date",
      responsivePriority: 5
    },
    {
      data: "purchase_order_id",
      title: "PO",
      responsivePriority: 2
    },
    {
      data: "status",
      filterName: "voided",
      responsivePriority: 4
    },
    {
      data: "job",
      responsivePriority: 10
    },
    ...customerClassificationColumns(),
    {
      data: "customer",
      className: "wrap-when-responsive",
      responsivePriority: 1
    },
    { data: "customer_email", title: "Email", responsivePriority: 9 },
    { data: "customer_phone", title: "Phone", responsivePriority: 8 },
    {
      data: "location_name",
      title: "Location Name",
      responsivePriority: 6
    },
    {
      data: "address",
      orderable: false,
      responsivePriority: 7
    },
    {
      data: "department",
      filterName: "department_id",
      responsivePriority: 11
    },
    {
      data: "type",
      title: "Category",
      filterName: "po_type",
      responsivePriority: 12
    },
    {
      data: "created_for",
      title: "For",
      filterName: "technician_id",
      responsivePriority: 13
    },
    { data: "vendor", filterName: "vendor", responsivePriority: 3 },
    {
      data: "amount",
      searchable: false,
      className: "text-right",
      responsivePriority: 14
    },
    {
      data: "description",
      className: "po-description-field",
      responsivePriority: 15
    }
  ],
  vueComponents: [
    {
      rootId: "purchase-order-modal-link",
      component: PurchaseOrderModalLink
    }
  ]
};

const store = useStore();

onMounted(() => {
  store.dispatch("addBreadcrumb", { label: "Purchase Orders" });
});
</script>

<style lang="scss">
td.po-description-field {
  white-space: normal;
}
</style>
